// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-chat-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}

/* Toggle Button */
.support-toggle-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4346ce 0%, #5558e3 100%);
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(67, 70, 206, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;
}

.support-toggle-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(67, 70, 206, 0.5);
}

.support-toggle-btn.open {
  background: #4346ce;
}

.toggle-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #e54b4d;
  color: white;
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Chat Widget */
.support-chat-widget {
  position: absolute;
  bottom: 80px;
  right: 0;
  width: 380px;
  max-height: 600px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Home View */
.support-home {
  display: flex;
  flex-direction: column;
  height: 600px;
}

.support-header {
  background: linear-gradient(135deg, #4346ce 0%, #6366f1 100%);
  padding: 20px;
  color: white;
  position: relative;
}

.support-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.support-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-icon {
  width: 32px;
  height: 32px;
  background: white;
  color: #4346ce;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.logo-text {
  font-size: 18px;
  font-weight: 600;
}

.support-avatars {
  display: flex;
  gap: -8px;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #2d2f8e;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  border: 2px solid #4346ce;
  margin-left: -8px;
}

.avatar:first-child {
  margin-left: 0;
}

.avatar.small {
  width: 28px;
  height: 28px;
  font-size: 12px;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.close-btn:hover {
  opacity: 1;
}

.support-greeting h2 {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 5px 0;
}

.support-greeting p {
  font-size: 24px;
  margin: 0;
  opacity: 0.9;
}

/* Body */
.support-body {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
  background: #f5f5f5;
}

.send-message-btn {
  width: 100%;
  padding: 16px 20px;
  background: white;
  border: none;
  border-radius: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
  transition: box-shadow 0.2s;
}

.send-message-btn:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.send-message-btn .arrow-icon {
  background: #4346ce;
  color: white;
  padding: 8px;
  border-radius: 50%;
  font-size: 12px;
}

.status-card {
  background: white;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.status-icon {
  width: 40px;
  height: 40px;
  background: #d4f5e2;
  color: #22c55e;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.status-info strong {
  display: block;
  font-size: 14px;
  color: #333;
}

.status-info p {
  margin: 0;
  font-size: 13px;
  color: #666;
}

.subscribe-btn {
  width: 100%;
  padding: 14px;
  background: #4346ce;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background 0.2s;
}

.subscribe-btn:hover {
  background: #3538b2;
}

.quick-links {
  background: white;
  border-radius: 12px;
  overflow: hidden;
}

.quick-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #eee;
  transition: background 0.2s;
}

.quick-link:last-child {
  border-bottom: none;
}

.quick-link:hover {
  background: #f9f9f9;
}

.quick-link svg {
  color: #999;
  font-size: 12px;
}

/* Footer */
.support-footer {
  display: flex;
  border-top: 1px solid #eee;
  background: white;
}

.footer-tab {
  flex: 1 1;
  padding: 12px;
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #666;
  font-size: 12px;
  position: relative;
  transition: color 0.2s;
}

.footer-tab.active {
  color: #4346ce;
}

.footer-tab svg {
  font-size: 20px;
}

.unread-badge {
  position: absolute;
  top: 8px;
  right: calc(50% - 20px);
  background: #e54b4d;
  color: white;
  font-size: 10px;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Messages List View */
.support-messages-list {
  display: flex;
  flex-direction: column;
  height: 600px;
}

.messages-header {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.messages-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.messages-header .close-btn {
  position: static;
  color: #666;
}

.conversations-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
}

.no-conversations {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.no-conversations button {
  margin-top: 16px;
  padding: 10px 20px;
  background: #4346ce;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.conversation-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.conversation-item:hover {
  background: #f5f5f5;
}

.conv-avatar {
  width: 40px;
  height: 40px;
  background: #4346ce;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.conv-info {
  flex: 1 1;
}

.conv-info strong {
  display: block;
  font-size: 14px;
  color: #333;
}

.conv-info p {
  margin: 0;
  font-size: 13px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.conv-unread {
  background: #e54b4d;
  color: white;
  font-size: 11px;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Chat View */
.support-chat-view {
  display: flex;
  flex-direction: column;
  height: 600px;
}

.chat-header {
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;
  gap: 12px;
}

.back-btn {
  background: transparent;
  border: none;
  color: #666;
  font-size: 16px;
  cursor: pointer;
  padding: 5px;
}

.chat-header-info {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-avatars {
  display: flex;
}

.chat-title {
  font-weight: 600;
  color: #333;
}

.chat-header-actions {
  display: flex;
  gap: 10px;
}

.more-btn {
  background: transparent;
  border: none;
  color: #666;
  font-size: 16px;
  cursor: pointer;
}

.chat-header .close-btn {
  position: static;
  color: #666;
}

/* Messages */
.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  background: #f9f9f9;
}

.message {
  max-width: 80%;
  padding: 12px 16px;
  border-radius: 16px;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.4;
}

.message p {
  margin: 0;
}

.admin-message {
  background: white;
  color: #333;
  border-bottom-left-radius: 4px;
}

.user-message {
  background: #4346ce;
  color: white;
  margin-left: auto;
  border-bottom-right-radius: 4px;
}

/* Chat Input */
.chat-input-container {
  padding: 15px;
  background: white;
  border-top: 1px solid #eee;
}

.chat-input-wrapper {
  border: 2px solid #4346ce;
  border-radius: 20px;
  padding: 12px 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chat-input-wrapper textarea {
  border: none;
  outline: none;
  resize: none;
  font-size: 14px;
  font-family: inherit;
  width: 100%;
  min-height: 24px;
  max-height: 100px;
}

.chat-input-wrapper textarea::placeholder {
  color: #999;
}

.input-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  background: transparent;
  border: none;
  color: #666;
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  transition: color 0.2s;
}

.action-btn:hover {
  color: #4346ce;
}

.send-btn {
  position: absolute;
  right: 25px;
  bottom: 25px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e0e0e0;
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  transition: all 0.2s;
}

.send-btn.active {
  background: #4346ce;
  cursor: pointer;
}

.send-btn.active:hover {
  background: #3538b2;
}

.chat-input-wrapper {
  position: relative;
}

.chat-input-container {
  position: relative;
}

/* Responsive */
@media (max-width: 480px) {
  .support-chat-widget {
    width: calc(100vw - 40px);
    max-height: calc(100vh - 100px);
    bottom: 70px;
    right: -10px;
  }
}


/* Emoji Picker */
.emoji-picker-container {
  position: static;
}

.emoji-picker {
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 8px 12px;
  display: flex;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

.emoji-picker button {
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: background 0.2s;
  line-height: 1;
}

.emoji-picker button:hover {
  background: #f0f0f0;
}

/* Recording State */
.action-btn.recording {
  color: #e54b4d;
  animation: pulse 1s infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}


/* Message Attachments */
.message-attachment img {
  max-width: 200px;
  max-height: 150px;
  border-radius: 8px;
}

.message-attachment a {
  color: inherit;
  text-decoration: none;
}

.user-message .message-attachment a {
  color: white;
}

.voice-msg {
  display: flex;
  align-items: center;
  gap: 8px;
}

.voice-msg audio {
  max-width: 180px;
  height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/components/app-support/SupportChat.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,YAAY;IACZ,YAAY;EACd;AACF;;;AAGA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;;AAGA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".support-chat-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999;\n}\n\n/* Toggle Button */\n.support-toggle-btn {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #4346ce 0%, #5558e3 100%);\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(67, 70, 206, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.support-toggle-btn:hover {\n  transform: scale(1.05);\n  box-shadow: 0 6px 16px rgba(67, 70, 206, 0.5);\n}\n\n.support-toggle-btn.open {\n  background: #4346ce;\n}\n\n.toggle-badge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background: #e54b4d;\n  color: white;\n  font-size: 12px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Chat Widget */\n.support-chat-widget {\n  position: absolute;\n  bottom: 80px;\n  right: 0;\n  width: 380px;\n  max-height: 600px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Home View */\n.support-home {\n  display: flex;\n  flex-direction: column;\n  height: 600px;\n}\n\n.support-header {\n  background: linear-gradient(135deg, #4346ce 0%, #6366f1 100%);\n  padding: 20px;\n  color: white;\n  position: relative;\n}\n\n.support-header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.support-logo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.logo-icon {\n  width: 32px;\n  height: 32px;\n  background: white;\n  color: #4346ce;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n.logo-text {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.support-avatars {\n  display: flex;\n  gap: -8px;\n}\n\n.avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #2d2f8e;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  border: 2px solid #4346ce;\n  margin-left: -8px;\n}\n\n.avatar:first-child {\n  margin-left: 0;\n}\n\n.avatar.small {\n  width: 28px;\n  height: 28px;\n  font-size: 12px;\n}\n\n.close-btn {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n}\n\n.close-btn:hover {\n  opacity: 1;\n}\n\n.support-greeting h2 {\n  font-size: 28px;\n  font-weight: 600;\n  margin: 0 0 5px 0;\n}\n\n.support-greeting p {\n  font-size: 24px;\n  margin: 0;\n  opacity: 0.9;\n}\n\n/* Body */\n.support-body {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n  background: #f5f5f5;\n}\n\n.send-message-btn {\n  width: 100%;\n  padding: 16px 20px;\n  background: white;\n  border: none;\n  border-radius: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 16px;\n  color: #333;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  margin-bottom: 16px;\n  transition: box-shadow 0.2s;\n}\n\n.send-message-btn:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.send-message-btn .arrow-icon {\n  background: #4346ce;\n  color: white;\n  padding: 8px;\n  border-radius: 50%;\n  font-size: 12px;\n}\n\n.status-card {\n  background: white;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.status-icon {\n  width: 40px;\n  height: 40px;\n  background: #d4f5e2;\n  color: #22c55e;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.status-info strong {\n  display: block;\n  font-size: 14px;\n  color: #333;\n}\n\n.status-info p {\n  margin: 0;\n  font-size: 13px;\n  color: #666;\n}\n\n.subscribe-btn {\n  width: 100%;\n  padding: 14px;\n  background: #4346ce;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-bottom: 20px;\n  transition: background 0.2s;\n}\n\n.subscribe-btn:hover {\n  background: #3538b2;\n}\n\n.quick-links {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.quick-link {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 16px;\n  color: #333;\n  text-decoration: none;\n  border-bottom: 1px solid #eee;\n  transition: background 0.2s;\n}\n\n.quick-link:last-child {\n  border-bottom: none;\n}\n\n.quick-link:hover {\n  background: #f9f9f9;\n}\n\n.quick-link svg {\n  color: #999;\n  font-size: 12px;\n}\n\n/* Footer */\n.support-footer {\n  display: flex;\n  border-top: 1px solid #eee;\n  background: white;\n}\n\n.footer-tab {\n  flex: 1;\n  padding: 12px;\n  background: transparent;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  color: #666;\n  font-size: 12px;\n  position: relative;\n  transition: color 0.2s;\n}\n\n.footer-tab.active {\n  color: #4346ce;\n}\n\n.footer-tab svg {\n  font-size: 20px;\n}\n\n.unread-badge {\n  position: absolute;\n  top: 8px;\n  right: calc(50% - 20px);\n  background: #e54b4d;\n  color: white;\n  font-size: 10px;\n  min-width: 16px;\n  height: 16px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Messages List View */\n.support-messages-list {\n  display: flex;\n  flex-direction: column;\n  height: 600px;\n}\n\n.messages-header {\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n}\n\n.messages-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n}\n\n.messages-header .close-btn {\n  position: static;\n  color: #666;\n}\n\n.conversations-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px;\n}\n\n.no-conversations {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n}\n\n.no-conversations button {\n  margin-top: 16px;\n  padding: 10px 20px;\n  background: #4346ce;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.conversation-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.conversation-item:hover {\n  background: #f5f5f5;\n}\n\n.conv-avatar {\n  width: 40px;\n  height: 40px;\n  background: #4346ce;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n}\n\n.conv-info {\n  flex: 1;\n}\n\n.conv-info strong {\n  display: block;\n  font-size: 14px;\n  color: #333;\n}\n\n.conv-info p {\n  margin: 0;\n  font-size: 13px;\n  color: #666;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 200px;\n}\n\n.conv-unread {\n  background: #e54b4d;\n  color: white;\n  font-size: 11px;\n  min-width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Chat View */\n.support-chat-view {\n  display: flex;\n  flex-direction: column;\n  height: 600px;\n}\n\n.chat-header {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n  gap: 12px;\n}\n\n.back-btn {\n  background: transparent;\n  border: none;\n  color: #666;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.chat-header-info {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chat-avatars {\n  display: flex;\n}\n\n.chat-title {\n  font-weight: 600;\n  color: #333;\n}\n\n.chat-header-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.more-btn {\n  background: transparent;\n  border: none;\n  color: #666;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.chat-header .close-btn {\n  position: static;\n  color: #666;\n}\n\n/* Messages */\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  background: #f9f9f9;\n}\n\n.message {\n  max-width: 80%;\n  padding: 12px 16px;\n  border-radius: 16px;\n  margin-bottom: 12px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.message p {\n  margin: 0;\n}\n\n.admin-message {\n  background: white;\n  color: #333;\n  border-bottom-left-radius: 4px;\n}\n\n.user-message {\n  background: #4346ce;\n  color: white;\n  margin-left: auto;\n  border-bottom-right-radius: 4px;\n}\n\n/* Chat Input */\n.chat-input-container {\n  padding: 15px;\n  background: white;\n  border-top: 1px solid #eee;\n}\n\n.chat-input-wrapper {\n  border: 2px solid #4346ce;\n  border-radius: 20px;\n  padding: 12px 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.chat-input-wrapper textarea {\n  border: none;\n  outline: none;\n  resize: none;\n  font-size: 14px;\n  font-family: inherit;\n  width: 100%;\n  min-height: 24px;\n  max-height: 100px;\n}\n\n.chat-input-wrapper textarea::placeholder {\n  color: #999;\n}\n\n.input-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.action-btn {\n  background: transparent;\n  border: none;\n  color: #666;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 4px;\n  transition: color 0.2s;\n}\n\n.action-btn:hover {\n  color: #4346ce;\n}\n\n.send-btn {\n  position: absolute;\n  right: 25px;\n  bottom: 25px;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #e0e0e0;\n  border: none;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: not-allowed;\n  transition: all 0.2s;\n}\n\n.send-btn.active {\n  background: #4346ce;\n  cursor: pointer;\n}\n\n.send-btn.active:hover {\n  background: #3538b2;\n}\n\n.chat-input-wrapper {\n  position: relative;\n}\n\n.chat-input-container {\n  position: relative;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .support-chat-widget {\n    width: calc(100vw - 40px);\n    max-height: calc(100vh - 100px);\n    bottom: 70px;\n    right: -10px;\n  }\n}\n\n\n/* Emoji Picker */\n.emoji-picker-container {\n  position: static;\n}\n\n.emoji-picker {\n  position: absolute;\n  bottom: 70px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: white;\n  border: 1px solid #eee;\n  border-radius: 12px;\n  padding: 8px 12px;\n  display: flex;\n  gap: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  z-index: 10;\n}\n\n.emoji-picker button {\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  transition: background 0.2s;\n  line-height: 1;\n}\n\n.emoji-picker button:hover {\n  background: #f0f0f0;\n}\n\n/* Recording State */\n.action-btn.recording {\n  color: #e54b4d;\n  animation: pulse 1s infinite;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n\n/* Message Attachments */\n.message-attachment img {\n  max-width: 200px;\n  max-height: 150px;\n  border-radius: 8px;\n}\n\n.message-attachment a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.user-message .message-attachment a {\n  color: white;\n}\n\n.voice-msg {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.voice-msg audio {\n  max-width: 180px;\n  height: 32px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
